let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aJBRF")).then(() => parcelRequire('5kNUg'));